 
 
 

import React from "react";
import { useCustomerPolicyDetails, useQueryParms,
} from "../../../../../hooks";
import { PageLoader } from "../../../../../components/PageLoader/PageLoader";
import { LoadState } from "../../../../../constants/enums";
import { StandadCard } from "../../../../../components/Cards";
import { TabsList } from "../../../../../components/Tabs/TabsList";
import {
  AccountCircle,
} from "@mui/icons-material";
import { TabPanel } from "../../../../../components/Tabs/TabPanel";
import { useNavigate, useOutletContext } from "react-router-dom";
import { LifeInsuranceCancellationList } from "./LifeInsuranceCancellation/LifeInsuranceCancellationList";

export const LifeInsurancePolicyFormsRoot = () => {
  const data = useOutletContext() as any;
  const customerId = data[0];
  const customerPolicyId = data[1];
const { getParm } = useQueryParms();
  const tabValue = getParm("tab");
  const selectedTab = tabValue ? Number(tabValue) : 0;

  const { details } = useCustomerPolicyDetails(
    customerPolicyId ? Number(customerPolicyId) : undefined
  );

  const navigate = useNavigate();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    navigate(
      `/life-insurance-policy/${customerId}/policy-forms-tab/${customerPolicyId}?tab=${newValue}`
    );
  };


  return (
    <PageLoader
      loading={details.loading === LoadState.InProgress}
      error={details.error ? { message: details.error } : null}
    >
      <StandadCard>
        <TabsList
          sx={{ mb: 1 }}
          varaint="fullWidth"
          selectedTab={selectedTab}
          tabs={[
            // {
            //     label: "Payment Authorization",
            //     icon: <AdminPanelSettings />,
            // },
            {
              label: "Cancellation",
              icon: <AccountCircle />,
            },
          ]}
          onChange={handleChange}
        />
        {/* <TabPanel value={selectedTab} index={0}>
          <HabitationalPaymentAuthorizationList
          />
        </TabPanel> */}
        <TabPanel value={selectedTab} index={0}>
          <LifeInsuranceCancellationList />
        </TabPanel>
      </StandadCard>
    </PageLoader>
  );
};
